export const BACKGROUND_COLORS_FOR_NOTES = ["#BC85A3", "#70C7C1", "#5C85A3"];
